import { api } from "../api";
import { Tag } from "../../model/tag/Tag";
import { parseTag } from "../../parsers/tags/parseTag";

export const getTags = async (): Promise<Tag[]> => {
  const response = await api.services.tag.getAllTags();
  return response.data.map(parseTag);
};
